import { formatCurrency } from "@/lib/utils"
import type { Contrato } from "../schema"

const SELOS = {
    REPASSADO: { texto: "Repassado", cor: "bg-ok-wash text-ok" },
    NAO_IDENTIFICADO: { texto: "Não identificado", cor: "bg-off-wash text-off" },
    EM_ANALISE: { texto: "Em análise", cor: "bg-sunk text-ink ring-1 ring-line-strong" },
    ACEITA: { texto: "Repasse aceito", cor: "bg-ok-wash text-ok" },
    RECUSADA: { texto: "Alegação recusada", cor: "bg-stop-wash text-stop" },
}

// O que a QI identificou vale mais que a alegação.
const Selo = ({ contrato: { situacao, alegacao } }: { contrato: Contrato }) => {
    const selo = SELOS[situacao === "REPASSADO" || !alegacao ? situacao : alegacao]
    return <span className={`rounded px-2 py-0.5 text-xs ${selo.cor}`}>{selo.texto}</span>
}

export const TabelaContratos = ({ contratos }: { contratos: Contrato[] }) => (
    <div className="overflow-hidden rounded-lg border border-line">
        <div className="hidden bg-sunk px-4 py-2 font-mono text-[0.64rem] uppercase tracking-[0.1em] text-faint sm:grid sm:grid-cols-[minmax(0,1fr)_7rem_6.5rem_7rem] sm:gap-3">
            <span>Colaborador</span>
            <span>Contrato</span>
            <span className="text-right">Valor</span>
            <span>Situação</span>
        </div>
        {contratos.map((contrato) => (
            <div
                key={contrato.contrato}
                className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1 border-t border-line px-4 py-3 text-sm sm:grid-cols-[minmax(0,1fr)_7rem_6.5rem_7rem]"
            >
                <div className="min-w-0">
                    <p className="truncate font-semibold">{contrato.colaborador}</p>
                    <p className="font-mono text-xs text-faint">CPF {contrato.cpfMascarado}</p>
                </div>
                <span className="col-start-1 font-mono text-xs text-soft sm:col-auto sm:text-sm">
                    {contrato.contrato}
                </span>
                <span className="row-start-1 text-right font-semibold tabular-nums sm:row-auto">
                    {formatCurrency(contrato.valor)}
                </span>
                <span className="col-start-2 justify-self-end sm:col-auto sm:justify-self-start">
                    <Selo contrato={contrato} />
                </span>
            </div>
        ))}
    </div>
)
